import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "plains-list" }
const _hoisted_2 = { class: "plains-list__item" }
const _hoisted_3 = { class: "avia-tarif-modal__title" }
const _hoisted_4 = {
  key: 0,
  class: "rail-modal-info"
}
const _hoisted_5 = { class: "rail-modal-info__wrapper" }
const _hoisted_6 = { class: "rail-modal-info-types" }
const _hoisted_7 = { class: "rail-modal-info-types__item" }
const _hoisted_8 = {
  key: 0,
  class: "rail-modal-info-types__item"
}
const _hoisted_9 = {
  key: 1,
  class: "rail-modal-info-types__item"
}
const _hoisted_10 = {
  key: 0,
  class: "rail-modal-info-services"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("h3", { class: "rail-modal-info-services__title" }, "Услуги вагона", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "rail-modal-info-services__descr" }, [
  /*#__PURE__*/_createVNode("p", { class: "rail-modal-info-services__text" }, " Купе-переговорная с четырьмя удобными кожаными креслами, столом, индивидуальной системой развлечений, презентационным оборудованием, системой кондиционирования. В стоимость входит – питание приготовленное по оригинальной рецептуре, алкогольные и безалкогольные напитки, пресса, дорожный набор, плед. "),
  /*#__PURE__*/_createVNode("p", { class: "rail-modal-info-services__text" }, " Купе-переговорная с четырьмя удобными кожаными креслами, столом, индивидуальной системой развлечений, презентационным оборудованием, системой кондиционирования. В стоимость входит – питание приготовленное по оригинальной рецептуре, алкогольные и безалкогольные напитки, пресса, дорожный набор, плед. ")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_single_dropdown = _resolveComponent("single-dropdown")
  const _component_rail_services = _resolveComponent("rail-services")
  const _component_rail_seats_select = _resolveComponent("rail-seats-select")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.localDisplay,
      "onUpdate:visible": _cache[4] || (_cache[4] = $event => (_ctx.localDisplay = $event)),
      dismissableMask: true,
      class: "p-dialog--hotels",
      modal: true,
      onShow: _ctx.getPricing
    }, {
      header: _withCtx(() => [
        _createVNode("ul", _hoisted_1, [
          _createVNode("li", _hoisted_2, _toDisplayString(_ctx.item.numberTrain), 1)
        ]),
        _createVNode("h3", null, _toDisplayString(_ctx.item.npScheduleHelper.fromTo[0]) + " - " + _toDisplayString(_ctx.item.npScheduleHelper.fromTo[1]), 1)
      ]),
      default: _withCtx(() => [
        _createVNode("h2", _hoisted_3, "Поезд " + _toDisplayString(_ctx.item.numberTrain), 1),
        (_ctx.localDisplay)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("ul", _hoisted_6, [
                  _createVNode("li", _hoisted_7, [
                    _createVNode(_component_single_dropdown, {
                      class: "rail-modal-dropdown",
                      selected: _ctx.fields.carriageSelected,
                      options: _ctx.carriageTypes,
                      placeholder: 'Тип вагона',
                      onSelect: _cache[1] || (_cache[1] = $event => (_ctx.selectProperty('carriageSelected', $event)))
                    }, null, 8, ["selected", "options"])
                  ]),
                  (_ctx.fields.carriageSelected)
                    ? (_openBlock(), _createBlock("li", _hoisted_8, [
                        _createVNode(_component_single_dropdown, {
                          class: "rail-modal-dropdown",
                          selected: _ctx.fields.classSelected,
                          options: _ctx.classOptions,
                          placeholder: 'Класс',
                          onSelect: _cache[2] || (_cache[2] = $event => (_ctx.selectProperty('classSelected', $event)))
                        }, null, 8, ["selected", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.fields.classSelected)
                    ? (_openBlock(), _createBlock("li", _hoisted_9, [
                        _createVNode(_component_single_dropdown, {
                          class: "rail-modal-dropdown",
                          selected: _ctx.fields.carriageNumber,
                          options: _ctx.carriageNumbers,
                          placeholder: 'Номер вагона',
                          onSelect: _cache[3] || (_cache[3] = $event => (_ctx.selectProperty('carriageNumber', $event)))
                        }, null, 8, ["selected", "options"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.selectedCarriage)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _hoisted_12,
                      _createVNode(_component_rail_services, { class: "rail-modal-info-services__icons" })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedCarriage)
          ? (_openBlock(), _createBlock(_component_rail_seats_select, {
              key: 1,
              selectedCarriage: _ctx.selectedCarriage,
              selectSeat: _ctx.selectSeat,
              save: _ctx.save
            }, null, 8, ["selectedCarriage", "selectSeat", "save"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onShow"])
  ]))
}